import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const EventActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

EventActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

EventActions.defaultProps = {
  basePath: '',
  data: {},
};

export default EventActions;
